import React, { useEffect, useState, useRef } from 'react'
import {
    Box, Select, Stack, Input, HStack, IconButton, Spinner, Center, Text, Alert, AlertDialog, AlertDialogBody, AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Icon,
    Collapse,
    Button,
    useToast,
} from '@chakra-ui/react'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import { useDispatch } from 'react-redux'
import {
    setAdminSidebarFalseOnUrlChange,
    setCurrentPageHeading,
} from '../../redux/common/commonActions'
import AdminBlockCard from '../../components/AdminBlockCard'
import { FiUpload, FiX, FiSave } from 'react-icons/fi'
import { Link } from '@chakra-ui/react'
import { postRequest } from '../../services/base.service'

const breadCrumb = [
    { label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
    { label: 'Import Businesses', isCurrentPage: true },
]

const ImportPage = () => {

    const dispatch = useDispatch()
    const toast = useToast()
    const [fileError, setFileError] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [isImporting, setIsImporting] = useState(false)

    useEffect(() => {
            dispatch(setCurrentPageHeading('Import Businesses'))
            dispatch(setAdminSidebarFalseOnUrlChange())
    }, [])

    const handleFileChange = (e) => {
        const file = e.target.files[0]

        if (!file) return

        const isCsv = file.type === 'text/csv' || file.name.endsWith('.csv')
        // const isLt8MB = file.size <= 8 * 1024 * 1024

        // if (!isCsv || !isLt8MB) {
        if (!isCsv) {
            let errorMsg = ''
            if (!isCsv) errorMsg = 'Only CSV files are allowed.'
            // if (!isLt8MB) errorMsg = 'File size should not exceed 8MB.'

            setFileError(errorMsg)
            toast({
                title: 'Invalid File',
                description: errorMsg,
                status: 'error',
                duration: 4000,
                isClosable: true,
            })
            return
        }
        setFileError(null)
        setSelectedFile(file)
        // console.log('Selected file:', file)
    }

    const handleImport = async () => {

        if (!selectedFile) return

        setIsImporting(true)
        const formData = new FormData()
        formData.append('file', selectedFile)
        postRequest(
                    `admin/business/import`, formData  
        )
        .then((res) => {
                toast({
                title: 'Success',
                description: res.message || 'Import completed successfully.',
                status: 'success',
                duration: 4000,
                isClosable: true,
            })
            setSelectedFile(null)
            setFileError(null)
        })
        .catch((err) => {
            if (err.response?.status === 422 && err.response?.data?.errors?.file) {
                const msg = err.response.data.errors.file[0]
                setFileError(msg)
                toast({
                    title: 'Validation Error',
                    description: msg,
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                })
            }
            else if (err.response?.status === 400) {
                const msg = err.response.data?.message || 'Import failed.'
                setFileError(msg)
                toast({
                    title: 'Import Error',
                    description: msg,
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                })
            }
            else {
                toast({
                    title: 'Unexpected Error',
                    description: 'Something went wrong. Please try again.',
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                })
            }
        })
        .finally(() => {
            setIsImporting(false)
        })

    }

    return (
            <>
                <AdminBreadcrumb items={breadCrumb} />
                <Box py={'7'}>
                    <AdminBlockCard
                        title={'Import Data'}
                    >
                            <HStack mt={5}>
                                <Button as="label" variant="brand" cursor="pointer">
                                    <HStack spacing="2">
                                        <Icon as={FiUpload} mb="2px" me="0" opacity="0.8" />
                                        <Text>Select CSV File</Text>
                                    </HStack>
                                    <input
                                        type="file"
                                        accept=".csv"
                                        hidden
                                        onChange={handleFileChange}
                                    />
                                </Button>
                                {selectedFile && (
                                    <HStack spacing={2}>
                                        <Text fontSize="sm" color="gray.600">
                                            {selectedFile.name}
                                        </Text>
                                        <IconButton
                                            aria-label="Remove file"
                                            icon={<FiX />}
                                            size="xs"
                                            variant="ghost"
                                            colorScheme="red"
                                            onClick={() => {
                                                setSelectedFile(null)
                                                setFileError(null)
                                            }}
                                        />
                                    </HStack>
                                )}
                            </HStack>
                            {fileError && <Text color="red.500">{fileError}</Text>}

                            <Text fontSize="sm" mt={5} color="gray.600">
                                Need help?{' '}
                                <Link color="blue.500" href="/sample-files/sample_import_business.csv" download>
                                    Click here
                                </Link>{' '}
                                to see a sample file structure.
                            </Text>

                            <Center mt={6}>
                                <Button
                                    variant="brand"
                                    onClick={handleImport}
                                    isDisabled={!selectedFile}
                                    leftIcon={<FiSave />}
                                    isLoading={isImporting}
                                >
                                    Import
                                </Button>
                            </Center>

                    </AdminBlockCard>
                </Box>
            </>
    )
}

export default ImportPage